<template>
  <div class="rt-label-item">
    <el-checkbox-button v-bind="$attrs"> <slot /> </el-checkbox-button>
  </div>
</template>

<script>
export default {
  name: 'RtLabelItem'
};
</script>

<style></style>



// WEBPACK FOOTER //
// rtLabelItem.vue?2439ed5a